<template lang="pug">
  div(v-if="timesheet")
    template(v-if="isApproved")
      template(v-if="currentUser.isManager")
        RouterLink(:to=" '/tours/' + tour.id + '/timesheet'" :target="props.target")
          Button(v-bind="attrs" :label="label" icon="ph ph-bold ph-check" severity="secondary" v-tooltip.top="'Timesheet'")
      template(v-else)
        Button(v-bind="attrs" :label="label" icon="ph ph-bold ph-check" severity="secondary" v-tooltip.top="'Timesheet'")    
    template(v-else)
      template(v-if="currentUser.isManager")
        RouterLink(:to=" '/tours/' + tour.id + '/timesheet'" :target="props.target")
          Button(v-bind="attrs" :label="label" icon="ph ph-bold ph-eye" severity="warn" v-tooltip.top="'Timesheet'")
      template(v-else)
        Button(v-bind="attrs" :label="label" icon="ph ph-bold ph-eye" severity="warn" v-tooltip.top="'Timesheet'")              
  div(v-else-if="needsTimesheet")
    template(v-if="currentUser.isManager")
      RouterLink(:to=" '/tours/' + tour.id + '/timesheet'" :target="props.target")
        Button(v-bind="attrs" :label="label" icon="ph ph-bold ph-clock-countdown" severity="info" v-tooltip.top="'Timesheet'")
    template(v-else)
      Button(v-bind="attrs" :label="label" icon="ph ph-bold ph-clock-countdown" severity="info" v-tooltip.top="'Timesheet'")            
</template>

<script setup>
import { useAttrs, computed } from 'vue'
import { useAuthStore } from "@/stores"

// Disable default attribute inheritance
defineOptions({
  inheritAttrs: false
})

const props = defineProps({
  tour:      { type: Object, default: {} },
  showLabel: { type: Boolean, default: true },
  target:    { type: String, default: null },
})

const attrs   = useAttrs()
const { currentUser } = useAuthStore()

const label = computed(() => {
  if (!props.showLabel) {
    return null
  }

  if (timesheet.value) {
    if (isApproved.value) {
      return 'Approved'
    } else {
      return 'Pending'
    }
  } else {
    return 'Timesheet'
  }
})

const needsTimesheet = computed(() => {
  return props.tour['needsTimesheet?']
})

const isApproved = computed(() => {
  return timesheet.value.isApproved
})

const timesheet = computed(() => {
  return props.tour.timesheet
})
</script>